import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackV2PageView } from '../services/tracking';

/** Scroll window to top on v2 route or query changes. */
export default function V2ScrollToTop() {
  const { pathname, search } = useLocation();
  const skipFirstPageView = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);

  useEffect(() => {
    const path = pathname + search;
    if (skipFirstPageView.current) {
      skipFirstPageView.current = false;
      return;
    }
    trackV2PageView({ path });
  }, [pathname, search]);

  return null;
}
